import { Button } from "@components/shared/core/Button";

export const TabbedSlideControls = ({
  total,
  ariaLabels,
  index: selectedIndex,
  setIndex,
}: {
  total: number;
  index: number;
  ariaLabels: string[];
  setIndex: (index: number) => void;
}) => {
  return (
    <div className="flex gap-2" role="tablist">
      {Array.from({ length: total }, (_, index) => (
        <Button
          key={index}
          onClick={() => setIndex(index)}
          variant="light-on-blur"
          role="tab"
          aria-label={ariaLabels[index]}
          aria-selected={index === selectedIndex}
          className="transition-all duration-long aria-selected:bg-palette-current-true aspect-square"
        >
          {index + 1}
        </Button>
      ))}
    </div>
  );
};
